import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@/store";

export const selectCallCentersState = (state: RootState) => state.callCenters;

export const selectCallCenters = createSelector(
  selectCallCentersState,
  (state) => state.callCenters
);

export const selectSelectedCallCenter = createSelector(
  selectCallCentersState,
  (state) => state.selectedCallCenter
);

export const selectSelectedCallCenterLoading = createSelector(
  selectCallCentersState,
  (state) => state.selectedCallCenterLoading
);

export const selectCallCentersLoading = createSelector(
  selectCallCentersState,
  (state) => state.loading
);

export const selectSelectionReady = createSelector(
  selectCallCentersState,
  (state) => state.selectionReady
);
